// API 请求封装，自动携带 token
const TOKEN_KEY = 'admin_token';

export function getToken() {
  return localStorage.getItem(TOKEN_KEY);
}

export async function apiFetch(url, options = {}) {
  const token = getToken();
  const headers = { ...(options.headers || {}) };
  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }
  const res = await fetch(url, { ...options, headers });
  if (res.status === 401) {
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem('admin_user');
    window.location.href = '/';
    throw new Error('未登录');
  }
  // 403 也直接抛错，防止下游 .then(J => setState(J)) 把 {error:'...'} 当成合法数据写入 state 导致 .map(undefined) 崩溃
  if (res.status === 403) {
    let msg = '无权限访问';
    try { const j = await res.clone().json(); if (j && j.error) msg = j.error; } catch {}
    throw new Error(msg);
  }
  return res;
}

// 上传文件（multipart）
export async function apiUpload(url, file, onProgress) {
  const token = getToken();
  const form = new FormData();
  form.append('file', file);
  const headers = {};
  if (token) headers['Authorization'] = `Bearer ${token}`;
  const res = await fetch(url, { method: 'POST', body: form, headers });
  if (res.status === 401) {
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem('admin_user');
    window.location.href = '/';
    throw new Error('未登录');
  }
  return res.json();
}

// 批量上传多文件（multipart，字段名 files）
export async function apiUploadMany(url, files, onProgress) {
  const token = getToken();
  const form = new FormData();
  files.forEach((f) => form.append('files', f));
  const headers = {};
  if (token) headers['Authorization'] = `Bearer ${token}`;
  const res = await fetch(url, { method: 'POST', body: form, headers });
  if (res.status === 401) {
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem('admin_user');
    window.location.href = '/';
    throw new Error('未登录');
  }
  return res.json();
}

// 数据变更全局通知：订单改编码/导入/商品成本/运费模板等变更后广播，各常驻页面静默刷新（保留筛选状态），避免跨页数据不同步
export function notifyDataChanged() {
  window.dispatchEvent(new CustomEvent('data-changed'));
}

// 监听数据变更：回调保留当前筛选状态重新加载
export function onDataChanged(cb) {
  const h = () => cb && cb();
  window.addEventListener('data-changed', h);
  return () => window.removeEventListener('data-changed', h);
}

// 下载文件（带鉴权），触发浏览器下载
export async function apiDownload(url, fallbackName = 'download.xlsx') {  const token = getToken();
  const headers = {};
  if (token) headers['Authorization'] = `Bearer ${token}`;
  const res = await fetch(url, { headers });
  if (res.status === 401) {
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem('admin_user');
    window.location.href = '/';
    throw new Error('未登录');
  }
  if (!res.ok) {
    throw new Error(`导出失败: ${res.status}`);
  }
  const blob = await res.blob();
  // 优先使用服务端 Content-Disposition 中的文件名（支持 UTF-8）
  let filename = fallbackName;
  const cd = res.headers.get('Content-Disposition');
  if (cd) {
    const star = cd.match(/filename\*=UTF-8''([^;]+)/i);
    if (star) {
      try { filename = decodeURIComponent(star[1]); } catch { /* ignore */ }
    } else {
      const m = cd.match(/filename="?([^";]+)"?/i);
      if (m) filename = m[1];
    }
  }
  const urlObj = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = urlObj;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  setTimeout(() => URL.revokeObjectURL(urlObj), 1000);
}
